import { lazy } from 'react';
import { MESSAGE_PERMISSIONS } from './constants';

const ThreadListPage = lazy(() => import('./pages/ThreadListPage'));
const ThreadDetailPage = lazy(() => import('./pages/ThreadDetailPage'));

export const messageRoutes = [
  {
    path: '/messages',
    element: ThreadListPage,
    permission: MESSAGE_PERMISSIONS.READ,
    nav: { labelKey: 'nav.messages', icon: 'MessageOutlined', group: 'operations' },
  },
  { path: '/messages/:id', element: ThreadDetailPage, permission: MESSAGE_PERMISSIONS.READ, nav: null },
];
